export default __webpack_public_path__ + "static/knowledge-b554b94fb1bbb2b5f67980351a909fe6.mp4";